import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "d-flex align-items-baseline justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentEntrancePlant.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("AppResourceEP.ParametersAndSettings")), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_TabView, {
        activeIndex: _ctx.adminView ? 1 : 0,
        class: "parameters-tabs p-tabview--custom",
        onTabChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTabClick($event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            disabled: _ctx.adminView,
            header: _ctx.$t('AppResourceEP.Structure')
          }, null, 8, ["disabled", "header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResourceEP.DevicesInfo')
          }, null, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResourceEP.DeviceLanguage')
          }, null, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResourceEP.CallMode')
          }, null, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResourceEP.AccessCode')
          }, null, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResourceEP.SubmitIssueDetails')
          }, null, 8, ["header"])
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ]),
    _createVNode("div", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tabContent), {
        ref: _ctx.tabContent,
        infoPlant: _ctx.infoPlant,
        onUpdateList: _ctx.handleUpdateList
      }, null, 8, ["infoPlant", "onUpdateList"]))
    ])
  ], 64))
}